import React, { useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import IconButton from '@material-ui/core/IconButton';
import axios from "axios";
import { CircularProgressbar } from "react-circular-progressbar";
import { ReactComponent as ExcelIcon } from "../../assets/svg/excel.svg";
import { useSimulateStyles, BodyTableRow, BodyTableCell } from "./simulation.style"
import { export_simulation_report } from "../../config/apiUrls";
import "react-circular-progressbar/dist/styles.css";


export default function SimulationResultTable(props) {
    const classes = useSimulateStyles();
    const { data, filter, headers, reportId } = props;
    const [filteredData, setFilteredData] = useState([])
    const [loading, setLoading] = useState(false);
    const [percentCompleted, setPercentCompleted] = useState(0);

    const getTotal = (data, key) => {
        return data.reduce((total, el) => total + el[key], 0)
    }
    React.useEffect(() => {
        let filteredData = data.contentTypes.map(el => {
            let temp = []
            let dataArr = el.mediums.filter(item => {
                let index = temp.indexOf(item.medium)
                if (index === -1) {
                    temp.push(item.medium)
                    return true
                }
                return false
            }).reduce((o, data) => ({ ...o, ["medium_" + headers.indexOf(data.medium)]: data }), {});
            // var maparr = new Map(dataArr)
            el.result = dataArr;
            return el
        })
        setFilteredData(filteredData)
    }, [data])
    const handleExcelDownload = _ => {
        setLoading(true);
        axios.post(export_simulation_report, { reportId: reportId }, {
            responseType: "blob",
            Accept: "blob",
            onDownloadProgress: (progressEvent) => {
                var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                setPercentCompleted(percentCompleted)
            }
        }).then(response => {
            setLoading(false);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `simulation_${reportId}.xlsx`); //or any other extension
            document.body.appendChild(link);
            link.click();
        })
            .catch((e) => {
                console.log('fetch failed', e);
                setLoading(false);
            });
        // try {
        //   const url = `${export_simulation_report}/${simulateResult.reportId}`;
        //   const link = document.createElement("a");
        //   link.href = url;
        //   link.setAttribute(
        //     "download",
        //     `simulation_${simulateResult.reportId}.xlsx`
        //   );
        //   document.body.appendChild(link);
        //   link.click();      
        // }
        // 
    }
    return (
        <>
            <div className={classes.nameCont} style={{ display: "flex", height: 45, alignItems: "flex-end", padding: "5px 20px" }}>
                <div className={classes.name}>{data ?.network}</div>
                {props.index === 0 && <div style={{ marginLeft: "auto", fontSize: "0.85rem", display: "flex", alignItems: "center" }}>
                    {!loading ? <IconButton style={{ padding: 4, marginRight: 10 }} onClick={handleExcelDownload}>
                        <ExcelIcon height={24} width={24} />
                    </IconButton> :
                        <div style={{ width: 40, marginRight: 10 }}>
                            <CircularProgressbar
                                value={percentCompleted}
                                text={
                                    <tspan dy={0}>{percentCompleted}%</tspan>
                                }
                            />
                        </div>
                    }
                    - Viewing Minutes represents (000s)</div>}
            </div>
            <TableContainer className={classes.tableCont} component={Paper} >
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <BodyTableCell style={{ width: 180, minWidth: 180, maxWidth: 180 }}>Content Type</BodyTableCell>
                            {headers && headers.map((header, index) => (
                                <BodyTableCell align="center" key={index}>{header}</BodyTableCell>
                            ))}
                            <BodyTableCell>Total</BodyTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            filteredData.length > 0 && filteredData.map((el, index) => (
                                <BodyTableRow key={index}>
                                    <BodyTableCell>{el.contentType}</BodyTableCell>
                                    {
                                        el.result && headers.map((medium, index1) => (
                                            <BodyTableCell align="center" key={index + "_" + index1}>
                                                {el.result["medium_" + index1] && filter === "uplift" && "+"}
                                                {el.result["medium_" + index1] ? filter === "uplift" ? el.result["medium_" + index1][filter] : el.result["medium_" + index1][filter].toLocaleString('en-US') : ""}
                                                {el.result["medium_" + index1] && filter === "uplift" && "%"}
                                            </BodyTableCell>
                                        ))
                                    }
                                    <BodyTableCell>{filter === "uplift" ? <>{`+${+parseFloat(getTotal(el.mediums, filter)).toFixed(2)}%`}</> : getTotal(el.mediums, filter).toLocaleString('en-us')}</BodyTableCell>
                                </BodyTableRow>
                            ))
                        }
                    </TableBody>
                </Table>

            </TableContainer>
        </>
    )
}